import Icon1 from "@assets/icons/Icon";
import BaseModal from "@components/modals/BaseModal";
import Button from "@components/ui/buttons/Button";
import AreaTextField from "@components/ui/textfields/AreaTextField";
import sendDiscordError from "@services/api/error/sendDiscordError";
import React, { useState } from "react";
import { createPortal } from "react-dom";

interface SupportMessageModalProps {
  value: string;
  onClose: () => void;
}

export default function SupportMessageModal({
  value,
  onClose,
}: SupportMessageModalProps) {
  const [textValue, setTextValue] = useState(value);

  const handleSendSupportMessage = async () => {
    await sendDiscordError(textValue);
    onClose?.();
  };

  const modalContent = (
    <BaseModal
      title="Demander de l'aide"
      startIcon={<Icon1 name="support" size={20}></Icon1>}
      onClose={onClose}
    >
      {/* Modal content */}
      <div className="flex flex-col text-h2 bg-neutral-50 p-3 border-b-1 ">
        <AreaTextField
          value={textValue}
          setValue={setTextValue}
          placeholder="Décrivez votre problème ici"
          rows={10}
        />
      </div>
      <div className="flex flex-row justify-end gap-2.5 p-3">
        <Button
          variant="small"
          label="Envoyer au support"
          onClick={handleSendSupportMessage}
        />
      </div>
    </BaseModal>
  );

  return createPortal(modalContent, document.body);
}
